<template>
  <v-footer app id="foot">
    <a href="mailto:dan@addtothestory.com?subject=Question about AddToTheStory.com" class="caption text-uppercase grey--text">Contact Us</a>
    <v-spacer></v-spacer>
    <router-link :to="{'name':'Policies'}" class="caption text-uppercase grey--text">Policies</router-link>
    <div class="caption ml-1">&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

#foot {
  background-color: #EBE8E8
}
</style>
